import { render, staticRenderFns } from "./InlineMessageContainer.vue?vue&type=template&id=098ebf98&scoped=true"
import script from "./InlineMessageContainer.vue?vue&type=script&lang=js"
export * from "./InlineMessageContainer.vue?vue&type=script&lang=js"
import style0 from "./InlineMessageContainer.vue?vue&type=style&index=0&id=098ebf98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098ebf98",
  null
  
)

export default component.exports